import './main.css'

import App from '@/App.vue'
import { getValidAccount, msal, VueNavigationClient } from '@/services/msal'
import { EventType, type AuthenticationResult } from '@azure/msal-browser'
import { PiniaColada, type PiniaColadaOptions } from '@pinia/colada'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'
import i18n from './translations'

const app = createApp(App)
app.use(createPinia())
app.use(PiniaColada, {
  staleTime: 1000 * 60 * 60 * 1, // 1 hour,
  refetchOnWindowFocus: false,
} as PiniaColadaOptions)
app.use(i18n)

const router = createRouter({
  history: createWebHistory(),
  routes,
})
if (import.meta.hot) {
  console.log('hot')
  handleHotUpdate(router)
}
const client = new VueNavigationClient(router)
msal.setNavigationClient(client)
const account = getValidAccount()
if (account !== undefined) {
  msal.setActiveAccount(account)
}
msal.addEventCallback(event => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult
    const account = payload.account
    msal.setActiveAccount(account)
  }
})
// set up auth and guard routes
router.beforeEach(async (to, _from, next) => {
  await msal.initialize()
  try {
    await msal.handleRedirectPromise()
  } catch {}
  if (to.meta.requiresAuth === false) {
    return next()
  }
  const account = getValidAccount()
  if (account !== undefined) {
    return next()
  }
  if (to.name === '/account/login') {
    return next()
  }
  return next({
    name: '/account/login',
    query: { redirect: to.fullPath },
  })
})
app.use(router)

router.isReady().then(() => {
  // Waiting for the router to be ready prevents race conditions
  // when returning from a loginRedirect or acquireTokenRedirect
  app.mount('#app')
})
